import React, { useEffect, useState } from 'react';

const imageBase = '/assets/images';

const carouselImages = [
  { src: `${imageBase}/carousel-1.jpg`, alt: 'Rive Moderne carousel slide 1' },
  { src: `${imageBase}/carousel-2.jpg`, alt: 'Rive Moderne carousel slide 2' },
  { src: `${imageBase}/carousel-3.jpg`, alt: 'Rive Moderne carousel slide 3' },
];

const featuredLinks = [
  { label: 'POUR LUI', src: `${imageBase}/pour-lui.jpg`, alt: 'Pour lui collection image' },
  { label: 'POUR ELLE', src: `${imageBase}/pour-elle.jpg`, alt: 'Pour elle collection image' },
];

export default function Home() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % carouselImages.length);
    }, 4500);
    return () => window.clearInterval(timer);
  }, []);

  const goTo = (nextIndex) => {
    setIndex(nextIndex);
  };

  const previous = () => {
    setIndex((current) => (current - 1 + carouselImages.length) % carouselImages.length);
  };

  const next = () => {
    setIndex((current) => (current + 1) % carouselImages.length);
  };

  return (
    <>
      <section className="carousel-section">
        <div className="carousel">
          <div
            className={`carousel__track carousel__track--${index}`}
          >
            {carouselImages.map((slide) => (
              <div key={slide.src} className="carousel__slide">
                <img src={slide.src} alt={slide.alt} className="carousel__image" />
              </div>
            ))}
          </div>

          <button className="carousel__control carousel__control--left" type="button" onClick={previous} aria-label="Previous slide">
            &#8249;
          </button>
          <button className="carousel__control carousel__control--right" type="button" onClick={next} aria-label="Next slide">
            &#8250;
          </button>

          <div className="carousel__dots">
            {carouselImages.map((slide, slideIndex) => (
              <button
                key={slide.src}
                className={`carousel__dot${slideIndex === index ? ' is-active' : ''}`}
                type="button"
                aria-label={`Show slide ${slideIndex + 1}`}
                onClick={() => goTo(slideIndex)}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="shop-category-section" aria-label="Featured collections">
        <div className="shop-category-grid">
          {featuredLinks.map((item) => (
            <button key={item.label} className="shop-category-card" type="button" aria-label={item.label}>
              <img src={item.src} alt={item.alt} className="shop-category-card__image" />
              <span className="shop-category-card__label">{item.label}</span>
            </button>
          ))}
        </div>
      </section>
    </>
  );
}
